export function StringToUrl (string) {
  return encodeURI(
    string
      .replace(new RegExp(' ', 'g'), '-')
      .replace(new RegExp('[.]', 'g'), '')
      .toLowerCase()
  )
};
